import gsap from 'gsap'

const CLICKABLE_SELECTOR = [
  '.highcharts-legend-item', // Highcharts 圖例
  // '.progress-bg', // 進度條背景
  // '.image-hover-shadow', // 圖片 hover 陰影
  // '.parent-icon', // 父層 icon
  '.site-icons', // 站點 icon
  'a', // 連結
  'button', // 按鈕
  'input', // 輸入框
  'label', // 標籤
  '[role="button"]', // ARIA button
  '[tabindex]:not([tabindex="-1"])', // 可聚焦元素
  '.cluster-rect',
  '.fa-sliders-h' // 右上角輪播設定 icon
].join(', ')

let cursor = null

const animateCursorScale = (targetScale, duration = 0.2, options = {}) => {
  gsap.to(cursor, {
    scale: targetScale,
    duration,
    ease: 'power2.out',
    ...options
  })
}

export function initCustomCursor () {
  const cursorHTML = `<div class="cursor"></div>`
  document.body.insertAdjacentHTML('afterbegin', cursorHTML)
  cursor = document.querySelector('.cursor')

  const moveCursor = (e) => {
    gsap.to(cursor, {
      x: e.clientX,
      y: e.clientY,
      duration: 0.15,
      ease: 'power2.out'
    })

    const isHoveringClickable = e.target.closest(CLICKABLE_SELECTOR)
    animateCursorScale(isHoveringClickable ? 5 : 1, 0.2)
  }

  const clickWave = (e) => {
    const isClickable = e.target.closest(CLICKABLE_SELECTOR)
    if (isClickable) {
      gsap.fromTo(
        cursor,
        { scale: 1.5 },
        {
          scale: 5,
          duration: 0.2,
          ease: 'power1.out',
          onComplete: () => {
            gsap.to(cursor, { scale: 5, duration: 0.1 })
          }
        }
      )
    } else {
      gsap.fromTo(
        cursor,
        { scale: 1 },
        {
          scale: 1.7,
          duration: 0.15,
          ease: 'power1.out',
          yoyo: true,
          repeat: 1,
          onComplete: () => {
            gsap.to(cursor, { scale: 1, duration: 0.1 })
          }
        }
      )
    }
  }

  window.addEventListener('mousemove', moveCursor)
  window.addEventListener('mousedown', clickWave)

  return () => {
    window.removeEventListener('mousemove', moveCursor)
    window.removeEventListener('mousedown', clickWave)
    cursor && cursor.remove()
    cursor = null
  }
}
